export default __webpack_public_path__ + "assets/angola-flag.png";